import red from '@material-ui/core/colors/red';

import { createTheme } from '@material-ui/core/styles'

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#E60012',
    },
    secondary: {
      main: '#a9b9d3',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
});

export default theme;
